import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const LabeledPraise = () => {
  return (
    <>
      <VideoAndShowPDFAfter
        pdfFile={pdfFiles.strategiesPart1[2]}
        vidSrc={1194418541}
      />
    </>
  );
};

export default LabeledPraise;
